import { useMemo } from 'react'
import parse from 'html-react-parser'
import { map, some } from 'lodash'

import { sectionsMap } from '@/components/sections'

import { WPPageData } from '@/types'

export type BuilderProps = {
  pageProps?: WPPageData
}

const Builder = ({ pageProps }: BuilderProps) => {
  const builder = useMemo(() => pageProps?.acf?.builder || [], [pageProps])

  // sections that render the page <h1> (only when they have a title, except heading/color-hero)
  const hasH1 = some(builder, ({ acf_fc_layout, title }) =>
    ['heading', 'color-hero'].includes(acf_fc_layout) ||
    (['hero', 'full-hero', 'home-hero', 'product-hero'].includes(acf_fc_layout) && !!title)
  )
  const pageTitle = pageProps?.title?.rendered

  return (
    <>
      {!hasH1 && pageTitle ? <h1 className="sr-only">{parse(pageTitle)}</h1> : null}
      {map(builder, ({ acf_fc_layout, ...section }, index) => {
        const Component = sectionsMap[acf_fc_layout]
        return Component ? <Component key={`${acf_fc_layout}-${index}`} {...section} /> : null
      })}
    </>
  )
}

export default Builder
